import { GetUsersIntegrationRequestModel } from "@/features/user/services/get-integration-model";
import { GetUsersIntegrationApi } from "@/features/user/services/get-integration-api";

// 統合ユーザ情報取得処理
export class GetUsersIntegrationService {
  private getUsersIntegrationApi = new GetUsersIntegrationApi();
  /**
   * 統合ユーザ情報取得実行
   */
  public async getUsersIntegration(param: GetUsersIntegrationRequestModel) {
    return await this.getUsersIntegrationApi.getUsersIntegration(param);
  }
}
